module.exports = __webpack_public_path__ + "static/media/woman-calculadora-aluguel-anage.9e6e6895.png";